/**
 * Dashboard formatting and date helpers
 */
export const formatPercent = (v) => (v != null && v !== '' ? `${Number(v).toFixed(1)}%` : '—');
export const formatNum = (v) => (v != null && v !== '' ? Number(v) : 0);
export const formatSales = (v) => (v != null && v !== '' ? String(v).replace(/^\$/, '').trim() || '—' : '—');
export const formatCurrency = (v) => {
  const n = Number(v);
  if (v == null || v === '' || Number.isNaN(n)) return '—';
  return `$${n.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
};

/** Pass date as YYYY-MM-DD */
export const toApiDate = (isoDate) => {
  if (!isoDate || !String(isoDate).trim()) return '';
  return String(isoDate).trim();
};


export const toTitleCase = (str) => {
  return String(str || '')
    .replace(/-/g, ' ')
    .replace(/\b\w/g, (char) => char.toUpperCase());
};